// extracted by mini-css-extract-plugin
export default {"takePic":"DocPicturePage_takePic__Jjh+I"};